'use client';

import React, { ReactNode, useMemo } from 'react';

import clsx from 'clsx';

import { Button } from '../Button';
import { ChevronDown, Globe } from '../Icons';

import styles from './ProfileMenu.module.scss';

interface ProfileMenuProps {
  className?: string;
  user: {
    name?: string;
    identifier?: string;
  };
  avatar?: React.ReactNode;
  children?: ReactNode;
}

export const ProfileMenu = ({ className, user, avatar, children }: ProfileMenuProps) => {
  const initials = useMemo(() => user.name?.charAt(0), [user.name]);

  return (
    <div className={clsx(styles.container, className)}>
      <button className={styles.button}>
        <div>{initials}</div>

        <span className={styles.accessory}>
          <ChevronDown size={20} />
        </span>
      </button>

      <div className={styles['menu-container']}>
        <nav className={styles.menu}>
          <div className={clsx(styles['menu-section'], styles['avatar-container'])}>
            {avatar ? avatar : <div className={styles.avatar}>{initials}</div>} {user.name}
          </div>

          <div className={styles['menu-section']}>{children}</div>
        </nav>
      </div>
    </div>
  );
};
